// docs: https://github.com/altostra/type-validations#readme
import { anyOf, arrayOf, objectOf, recordOf } from "@altostra/type-validations";
import { boolean, nullValidation, number, string } from "@altostra/type-validations/lib/primitives";

import type {
  DeleteDecisioningStudioAgentsBaseCreativeResult,
  PutDecisioningStudioAgentsBaseCreativeResult,
} from "./types";

export const isPostDecisioningStudioAgentsBaseCreativeResult = objectOf({
  id: string,
});

const isBaseCreativeAction = objectOf<PutDecisioningStudioAgentsBaseCreativeResult["action"]>({
  actionId: number,
  creative: string,
  liquidSupport: recordOf<Record<string, boolean>>(boolean),
});

const isBaseCreativeWarning = objectOf<PutDecisioningStudioAgentsBaseCreativeResult["warnings"][number]>({
  message: string,
});

export const isPutDecisioningStudioAgentsBaseCreativeResult =
  objectOf<PutDecisioningStudioAgentsBaseCreativeResult>({
    action: isBaseCreativeAction,
    warnings: arrayOf(isBaseCreativeWarning),
  });

export const isDeleteDecisioningStudioAgentsBaseCreativeResult =
  objectOf<DeleteDecisioningStudioAgentsBaseCreativeResult>({
    deletedActionId: anyOf(number, nullValidation),
  });
